import { shouldPolyfill } from "@formatjs/intl-pluralrules/should-polyfill";
import { SupportedLanguage } from "./SupportedLanguage";

export async function polyfillIntlPluralRules(locale: SupportedLanguage) {
  // This doesn't return a boolean. Instead it returns undefined if the
  // locale is supported and the locale string in case it's not supported
  const unsupportedLocale = shouldPolyfill(locale);

  // This locale is supported
  if (!unsupportedLocale) {
    return;
  }
  // Load the polyfill 1st BEFORE loading data
  await import("@formatjs/intl-pluralrules/polyfill-force");

  switch (locale) {
    case SupportedLanguage.EN: {
      await import(`@formatjs/intl-pluralrules/locale-data/en`);
      break;
    }
    case SupportedLanguage.HR: {
      await import(`@formatjs/intl-pluralrules/locale-data/hr`);
      break;
    }
    default: {
      await import(`@formatjs/intl-pluralrules/locale-data/en`);
    }
  }
}
